


























































import router from '@/routes';
import Component from 'vue-class-component';
import NotificationDialog from './notification-dialog.vue';

@Component({
  components: {},
  directives: {}
})
export default class NotificationPrescriptionDialog extends NotificationDialog {
  prescribe(editable) {
    if (this.preview) {
      this.dialog.show('alert', 'Pré-visualização', 'Somente demonstração.');
      return;
    }
    let n = this.notification as any;
    if (n.expirado) {
      this.closeForm();
      return;
    }
    let urlRedirect = `/prescricao?idCp=${n.idPrescricao}&editable=${editable}&t=${new Date().getTime()}&idNotif=${
      n.id
    }`;
    urlRedirect = encodeURIComponent(urlRedirect);
    router.push(`?redirect=${urlRedirect}&emp=${n.idEmpresa}`);
    this.closeForm();
  }
}
